import {
  SUCCESS_FLASH_MESSAGE,
  ERROR_FLASH_MESSAGE,
  HIDE_FLASH_MESSAGE,
} from '../types/FlashTypes';

const initialState = {
  message: '',
  state: '',
  timeout: 6000,
  visible: false,
};

const flashReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_FLASH_MESSAGE:
      return {
        ...state,
        state: 'success',
        message: action.message,
        visible: true,
      };
    case ERROR_FLASH_MESSAGE:
      return {
        ...state,
        state: 'error',
        message: action.message,
        visible: true,
      };
    case HIDE_FLASH_MESSAGE: {
      return { ...state, visible: false };
    }
    default:
      return state;
  }
};

export default flashReducer;
